 // Formatting the date
 const formatDate = (date) => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = `0${d.getMonth()+1}`.slice(-2)
    const day = (d.getDate() - 2) <= 9 ? `0${d.getDate() - 2}` : (d.getDate() - 2)

    return `${year}-${month}-${day}`
  }

  export default formatDate